import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const CustomCheckBox = ({
  data,
  dispatch,
  reduxFunc,
  title,
  index: index2,
}) => {
  const handleChecked = (index) => {
    if (typeof index2 !== "undefined") {
      dispatch(reduxFunc({ index: index, index2: index2 }));
    } else {
      dispatch(reduxFunc(index));
    }
  };
  return (
    <div>
      <FormControl>
        <FormLabel>{title}</FormLabel>
        <FormGroup style={{ display: "inline-block" }}>
          {data.map((d, index) => {
            return (
              <FormControlLabel
                control={<Checkbox checked={d.checked} />}
                label={d.label}
                onChange={() => handleChecked(index)}
              />
            );
          })}
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default CustomCheckBox;
